/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrandShow_brand$ref = any;
export type BrandShowQueryVariables = {|
  brandId: string
|};
export type BrandShowQueryResponse = {|
  +brand: ?{|
    +$fragmentRefs: BrandShow_brand$ref
  |}
|};
export type BrandShowQuery = {|
  variables: BrandShowQueryVariables,
  response: BrandShowQueryResponse,
|};
*/


/*
query BrandShowQuery(
  $brandId: ID!
) {
  brand: store(id: $brandId) {
    ...BrandShow_brand
    id
  }
}

fragment BrandShow_brand on Store {
  id
  name
  phoneNumber
  storeNumber
  defaultCashbackRate
  birthdayCashbackRate
  uniqueInState
  fastCashEnabled
  normalOpeningHour
  normalClosingHour
  sundayOpeningHour
  sundayClosingHour
  customerServiceEmail
  isFeatured
  email
  logoUrl
  imageUrl
  locationMapUrl
  shareableUrl
  appUrl
  billingAddress
  categories {
    id
    name
  }
  offers(first: 1000, all: true) {
    edges {
      node {
        id
        startDate
        endDate
        ...OfferList_offers
      }
    }
  }
}

fragment OfferCell_offer on Offer {
  id
  title
  description
  store {
    name
    id
  }
  imageUrl
  startDate
  endDate
  isFlash
  isLatest
  isPromoted
  isRedeemable
  isCheckIn
  redemptionCode
  finePrint
  isTop
  shareableUrl
  appUrl
}

fragment OfferList_offers on Offer {
  id
  ...OfferCell_offer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brandId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shareableUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandShowQuery",
    "selections": [
      {
        "alias": "brand",
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandShow_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandShowQuery",
    "selections": [
      {
        "alias": "brand",
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storeNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultCashbackRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "birthdayCashbackRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uniqueInState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fastCashEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "normalOpeningHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "normalClosingHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayOpeningHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayClosingHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerServiceEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFeatured",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationMapUrl",
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "all",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "store",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFlash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isLatest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPromoted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRedeemable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCheckIn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "redemptionCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finePrint",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isTop",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "offers(all:true,first:1000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "BrandShowQuery",
    "operationKind": "query",
    "text": "query BrandShowQuery(\n  $brandId: ID!\n) {\n  brand: store(id: $brandId) {\n    ...BrandShow_brand\n    id\n  }\n}\n\nfragment BrandShow_brand on Store {\n  id\n  name\n  phoneNumber\n  storeNumber\n  defaultCashbackRate\n  birthdayCashbackRate\n  uniqueInState\n  fastCashEnabled\n  normalOpeningHour\n  normalClosingHour\n  sundayOpeningHour\n  sundayClosingHour\n  customerServiceEmail\n  isFeatured\n  email\n  logoUrl\n  imageUrl\n  locationMapUrl\n  shareableUrl\n  appUrl\n  billingAddress\n  categories {\n    id\n    name\n  }\n  offers(first: 1000, all: true) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        ...OfferList_offers\n      }\n    }\n  }\n}\n\nfragment OfferCell_offer on Offer {\n  id\n  title\n  description\n  store {\n    name\n    id\n  }\n  imageUrl\n  startDate\n  endDate\n  isFlash\n  isLatest\n  isPromoted\n  isRedeemable\n  isCheckIn\n  redemptionCode\n  finePrint\n  isTop\n  shareableUrl\n  appUrl\n}\n\nfragment OfferList_offers on Offer {\n  id\n  ...OfferCell_offer\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b96596eb829e529a12c18d9feb0e84a';

module.exports = node;
